export enum LoadingStatus {
  Idle = 0,
  Loading = 1,
  Failed = 2,
}
